import { render, staticRenderFns } from "./AddBloc.vue?vue&type=template&id=72a20a00&scoped=true&"
import script from "./AddBloc.vue?vue&type=script&lang=js&"
export * from "./AddBloc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a20a00",
  null
  
)

export default component.exports